module.exports = __webpack_public_path__ + "static/media/email-icon-light.372f7716.png";